// TODO: Better to create a full NagerDate module and map all their api calls
export async function getUpcomingHolidays(countryCode = "SE") {
  const response = 
    await fetch(`https://date.nager.at/api/v3/NextPublicHolidays/${countryCode}`);

  const upcomingHolidays: Holiday[] = await response.json();
  return upcomingHolidays;
}

type Holiday = {
  date: string; // yyyy-MM-dd
  localName?: string;
  name?: string;
  countryCode?: string;
  fixed: boolean;
  global: boolean;
  counties?: string[];
  launchYear?: number; 
  types?: HolidayType[];
}

type HolidayType =
  | "Public" 
  | "Bank"
  | "School"
  | "Authorities" 
  | "Optional"
  | "Observance"
